// extracted by mini-css-extract-plugin
export default {"routes":"app_routes__+UX4v"};